import script from "./SyncHealth.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncHealth.vue?vue&type=script&setup=true&lang=js"

import "./SyncHealth.vue?vue&type=style&index=0&id=73bf2600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73bf2600"]])

export default __exports__